import { datePickerSharedProps as o, selectionModeWithDefault as e } from "./index935.js";
import { buildProps as t } from "./index601.js";
const s = t({
  ...o,
  selectionMode: e("month")
});
export {
  s as basicMonthTableProps
};
